/* global translation */

import { hideOnClickOutside, triggerEvent } from './functions';

const miniLangSelectorContainer = document.getElementById('mini-lang-selector');
const miniLangSelectorButtons = Array.from(document.getElementsByClassName('toggle-lang-selector'));

miniLangSelectorButtons.forEach((link) => {
  link.addEventListener('click', (event) => {
    event.preventDefault();

    hideOnClickOutside(miniLangSelectorContainer, 'open-lang-selector');

    document.body.classList.remove('open-mobile-menu');

    // Prevents the menu to be opened again if it already was open.
    // hideOnClickOutside() will close it if it's open
    if (document.body.classList.contains('open-lang-selector')) {
      return;
    }

    // This is inside of a timout to prevent it from being closed by hideOnClickOutside() as soon as it's opened
    setTimeout(() => {
      document.body.classList.add('open-lang-selector');
    });
  }, 10);
});

const languageSelectorForm = document.getElementById('language-selector');
if (languageSelectorForm) {
  languageSelectorForm.addEventListener('submit', (event) => {
    event.preventDefault();
    const submitButton = languageSelectorForm.querySelector('.button');
    submitButton.classList.add('wait');

    const payload = {
      language: document.language_selector.language.value,
      shipping: document.language_selector.shipping_country.value,
    };

    jQuery.post(translation.set_selected_country, payload, (response) => {
      if (response.success) {
        window.location.reload();
      }
    });
  });
}


const mobileLanguageSelectorForm = document.getElementById('menu-language-selector');
if (mobileLanguageSelectorForm) {
  mobileLanguageSelectorForm.addEventListener('submit', (event) => {
    event.preventDefault();
    const submitButton = mobileLanguageSelectorForm.querySelector('.button');
    submitButton.classList.add('wait');

    const payload = {
      language: document.menu_language_selector.language.value,
      shipping: document.menu_language_selector.shipping_country.value,
    };

    jQuery.post(translation.set_selected_country, payload, (response) => {
      if (response.success) {
        window.location.reload();
      }
    });
  });
}


const fragmentLanguageChecker = () => {
  const html = document.querySelector('html');
  const language = html.attributes.lang.value;
  const miniCart = document.querySelector('#mini-cart .dropdown-product-list-container-inner');
  const miniCartLang = miniCart.dataset.language;

  if (miniCartLang) {
    if (!language.includes(miniCartLang)) {
      jQuery(document.body).trigger('wc_fragment_refresh');
    }
  }
};

setTimeout(() => {
  fragmentLanguageChecker();
}, 200);
